<agpr-dialog-container
    id="SaveTwigTemplateDialog"
    [heading]="(heading | localize) + (headingType + this._type | localize)"
    (close)="cancel()"
>
    <div class='agpr-saveTwigTemplateDialog-content'>
        <agpr-message
            [severity]="messageSeverityEnum.info"
        >
            {{ 'Styles.saveTwigTemplateDialog.infoBanner' | localize }}
        </agpr-message>
        <div class="agpr-saveTwigTemplateDialog-editorWrapper">
            <div class="agpr-saveTwigTemplateDialog-editorHeader">
                <span>
                    {{ 'Styles.saveTwigTemplateDialog.blockTypeLabel' | localize }}: {{'Styles.saveTwigTemplateDialog.type' + this._type | localize }}
                </span>
                <agpr-button
                    [style]="buttonTypesEnum.tertiary"
                    [label]="'Styles.saveTwigTemplateDialog.resetToDefault'"
                    (click)="resetTemplate()"
                >
                </agpr-button>
            </div>
            <div class="agpr-saveTwigTemplateDialog-editorBody">
                <div class="agpr-saveTwigTemplateDialog-editorBodyTextAreaWrapper">
                    <textarea
                        class="agpr-saveTwigTemplateDialog-editorBodyTextArea"
                        rows="20"
                        [(ngModel)]="inputStyle.template.template"
                        (ngModelChange)="validate()"
                    ></textarea>
                </div>
                <div class="agpr-saveTwigTemplateDialog-editorBodySideBar">
                    <div class="agpr-saveTwigTemplateDialog-editorBodySideBarHeader">
                        {{ 'Styles.saveTwigTemplateDialog.documentationHeader' | localize }}
                    </div>
                    <agpr-scroll-panel>
                        <ul>
                            <li
                                *ngFor="let documentation of documentationArray"
                                [pTooltip]="documentation.tooltip | localize"
                                tooltipPosition="left"
                                class="agpr-saveTwigTemplateDialog-editorBodySideBarListItem"
                            >
                                {{ documentation.label | localize }}
                            </li>
                        </ul>
                    </agpr-scroll-panel>
                </div>
            </div>
        </div>

    </div>

    <ng-template #footerLeft>
        <div>
            <agpr-button
                id="Styles.saveTwigTemplateDialog.cancel"
                label="Styles.saveTwigTemplateDialog.cancelLabel"
                [style]="buttonTypesEnum.secondary"
                (click)="cancel()"
            ></agpr-button>
        </div>
    </ng-template>
    <ng-template #footerRight>
        <div>
            <agpr-button
                id="Styles.saveTwigTemplateDialog.ok"
                [style]="buttonTypesEnum.primary"
                [label]="okLabel"
                [disabled]="!formValid"
                (click)="ok()"
            >
            </agpr-button>
        </div>
    </ng-template>
</agpr-dialog-container>
